export const FETCH_GROUP_TICKERS_REQUEST = 'FETCH_GROUP_TICKERS_REQUEST';
export const FETCH_GROUP_TICKERS_SUCCESS = 'FETCH_GROUP_TICKERS_SUCCESS';
export const FETCH_GROUP_TICKERS_FAILURE = 'FETCH_GROUP_TICKERS_FAILURE';
export const FETCH_TICKERS_REQUEST = 'FETCH_TICKERS_REQUEST';
export const FETCH_TICKERS_SUCCESS = 'FETCH_TICKERS_SUCCESS';
export const FETCH_TICKERS_FAILURE = 'FETCH_TICKERS_FAILURE';
export const SET_CURRENT_TICKERS = 'SET_CURRENT_TICKERS';